export default __webpack_public_path__ + "5c0a0412007109b2802086841d9a16ff.svg";